<app-header></app-header>

<!-- Old Code -->
<div class="ethics">
  <div class="ethics_top text-center">
    <ng-container *ngFor="let heading of head">
      <div
        class="bg_6 inline_padding2 ethics_top_box"
        *ngIf="heading.page === currentPage"
      >
        <div class="ethics_top_box_inner">
          <div class="inline_padding3">
            <span class="text_style_5">Code of Ethics</span>
          </div>
          <div class="inline_padding3 p-top-16">
            <span
              class="text_style_1"
              [innerHtml]="heading.page_sub_heading"
            ></span>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <div class="inline_padding1 ethics_bottom">
    <div class="ethics_bottom_body">
      <div class="border_right_blue">
        <ng-container *ngFor="let ethics of data; let i = index">
          <div
            class="edit_body_heading width-100-per"
            (click)="toggleDescription(i)"
            [ngClass]="{ 'right-border-3': highlightedIndex === i }"
            [id]="'item-' + i"
          >
            <div class="width-100-per">
              <div class="cursor-pointer m-r-3-neg m-r-3-neg">
                <div class="p-y-18">
                  <span
                    id="title-{{ i }}"
                    [innerHtml]="ethics.title"
                    [ngClass]="{
                      text_blue_16: highlightedIndex === i,
                      text_black_14: highlightedIndex !== i
                    }"
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="ethics_bottom_body_description">
        <ng-container *ngFor="let ethics of data; let i = index">
          <div
            class="p-x-30 p-y-40"
            [ngClass]="{ bottom_border_trans_5: i !== data.length - 1 }"
          >
            <div
              class="right text_style_9 text_align-justify"
              [id]="'description-' + i"
              [innerHtml]="ethics.description"
            ></div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- New Code -->
<!-- <div class="title-box">

    <div class="top-text-container ">
        <div class="text-heading">Code of Ethics</div>
        <div class="text-containt" [innerHtml]="head[0].page_sub_heading"></div>
    </div>
    <div class="row class-all ">
        <div class="col-12 col-xl-4 text-start box1 ">
            <div class="all-content">
                <a *ngFor="let elem of data" (click)="scrollToSection(elem.title)" class="active"
                    [ngClass]="selected === elem.title ? 'isSelected' : ''">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"
                        style="width: 25px; margin-right: 10px;" *ngIf="selected === elem.title">
                        <path
                            d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z">
                        </path>
                    </svg>
                    {{ elem.title }}
                </a>
            </div>
        </div>
        <div class="col-12 col-xl-8 box2 pt-3 pt-xl-0">
            <div *ngFor="let elem2 of data" class="content1" id="{{elem2.title}}" (scroll)="onScroll($event)">
                <h2>{{ elem2.title }}</h2>
                <p [innerHtml]="elem2.description"></p>
                <hr />
            </div>
        </div>
    </div>
</div> -->

<app-footer></app-footer>
